// @ts-check
import { useQuery } from '@tanstack/react-query';
import api from 'modules/queries/api';

/**
 * @param {object} options
 * @param {import('@tanstack/react-query').UseQueryOptions['enabled']} [options.enabled]
 */
const useWhatismyip = ({ enabled } = {}) =>
	useQuery({
		queryKey: ['/utilities/info/whatismyip'],
		queryFn: () => api.utilities.info.apiRaw.whatismyip(),
		enabled,
	});

export default useWhatismyip;
